import { createStore, combineReducers } from 'redux';
import documentsReducer from './documentsReducer';

const rootReducer = combineReducers({
  documentsReducer,
});

export default createStore(rootReducer);
